<template>
  <div>
    <div v-if="!showDomainInput" class="pb-domain-term pull-left">
      {{ $t('common.domain') }}:
      <a v-if="!itemIsDomainRegistration" class="link-info" @click="showDomainInput = !showDomainInput">{{ item.options.domain }}</a>
      <span v-else>{{ item.options.domain }}</span>
    </div>
    <div v-show="showDomainInput">
      <div class="pb-terms">
        <div class="title">
          {{ $t('common.domain') }}
          <span class="tip" data-placement="top" title="" data-bs-toggle="tooltip" :data-bs-title="tooltip">
            <i class="fa fa-info-circle"></i>
          </span>
        </div>
        <div class="pull-left w-100 mb-0 d-flex flex-row gap-0">
          <div class="w-100 pl-0 pr-0">
            <span class="error-red" :class="{ hide: !display_error }">
              <i class="noip-icons-error-noip-icons-01" />
            </span>
            <input v-model="input_domain" @keyup.enter="updateDomain" class="form-control" :placeholder="enter_domain" :class="{ 'border-1 border-danger focus-ring-danger': display_error }" />
            <div id="domain-error" class="col-sm-12 pl-0 pr-0 w-100" role="alert" :class="{ hide: !display_error }">
              <span class="text-danger csr-danger no-margin">{{ display_error }}</span>
            </div>
          </div>
          <div class="pull-left d-inline pb-w-100-btn pt-10 pt-md-0 ms-n1">
            <button v-track="{ category: 'plan-builder', action: 'add', label: 'add-domain' }" class="btn btn-pb-cc fw-bold pb-buttons-padding" @click="updateDomain">{{ $t('common.add') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DomainInput',

  props: {
    item: {
      type: Object,
      required: true
    },

    cart_error: {
      type: String,
      required: false
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    tooltip: function () {
      return this.$t('domain_input.tooltip');
    },
    enter_domain: function () {
      return this.$t('common.enter_domain');
    },
    display_error: function () {
      if (this.cart_error) {
        return this.cart_error;
      } else if (this.domain_error) {
        return this.domain_error;
      } else {
        return '';
      }
    },
    // users should not be able to edit the domain of domain reg products once
    // it's in the cart
    itemIsDomainRegistration: function () {
      return this.item.product_id === 'registration.domain';
    }
  },

  data() {
    return {
      showDomainInput: !this.item.options.domain,
      input_domain: this.item.options.domain ? this.item.options.domain : '',
      domain_error: ''
    };
  },

  methods: {
    ...mapActions('cart', ['updateProduct']),

    updateDomain() {
      let domain = this.input_domain.toLowerCase();

      if (!domain) {
        this.domain_error = 'Domain is required';
        return;
      }

      if (this.item.options.domain === domain) {
        this.showDomainInput = false;
        return;
      }

      let product_data = {
        id: this.item.id,
        product_id: this.item.product_id,
        term: this.item.term,
        quantity: this.item.options.quantity,
        domain: domain
      };

      let product_id = product_data['product_id'];

      this.$emit('update:loading', true);

      // eslint-disable-next-line no-undef
      axios.get('/domain/is-valid', { params: { domain, product_id } }).then(response => {
        if (!response.data.is_valid) {
          this.$emit('update:loading', false);
          this.domain_error = 'Sorry, the domain you entered is invalid';
          return;
        }

        this.updateProduct(product_data)
          .then(() => {
            this.showDomainInput = false;
            this.$emit('update:loading', false);
          })
          .catch(errors => {
            if (Array.isArray(errors)) {
              this.domain_error = errors[0];
            } else {
              this.domain_error = errors;
            }

            this.$emit('update:loading', false);
          });
      });
    }
  }
};
</script>
